module.exports = "https://coursera_assets.s3.amazonaws.com/images/51ac44ba4d43ccbaa0f343d91e58260f.png";